<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="sm"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class>{{ $t("EmbedYourWebsite") }}</h4>
        <p class="mt-5">
          {{ $t("CompnayId") }}:
          <strong>{{ company.company_name }}</strong>
        </p>

        <div
          v-if="$store.getters.roles != 'staff'"
          class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 switch"
        >
          <div class="flex items-center walk-card mb-4 mt-10">
            <b-form-checkbox
              id="tooltip-target-1"
              v-model="enable"
              size="lg"
              name="cell_width"
              switch
              @input="setHeader"
            >
            </b-form-checkbox>
            <!-- <vs-switch v-model="users.enable" /> -->
            <span class="ml-4">{{ $t("EmbeddedHeaderFooter") }}</span>
          </div>
        </div>
        <h5 class="mt-10">{{ $t("AppointmentBookingWidget") }}</h5>
        <p class="mt-4">{{ $t("AppointmentBookingWidgetText") }}</p>

        <div class="vx-col">
          <label class="vs-input--label"
            >{{ $t("Department") }} <span class="red">*</span></label
          >

          <v-select
            name="department"
            id="department"
            class=""
            v-model="embedCodeDepartment"
            label="department_name"
            :options="options"
            :data-vv-as="$t('Department')"
            outlined
            :menu-props="{ maxHeight: 200 }"
            :placeholder="$t('Search')"
          >
            <template v-slot:option="option">
              <span :class="option.icon">{{ option.department_name }} </span>
              <feather-icon
                v-if="
                  embedCodeDepartment && embedCodeDepartment.id == option.id
                "
                icon="CheckIcon"
                class="float-right"
                svgClasses="w-5 h-5"
              />
            </template>
          </v-select>
        </div>
        <div class="mt-5" style="border: 1px solid">
          <feather-icon
            class="float-right mt-1 mr-1"
            style="cursor: pointer"
            v-b-tooltip.hover
            :title="$t('Copy')"
            icon="CopyIcon"
            svgClasses="w-6 h-6 hover:text-danger stroke-current"
            @click="copyCode(embedCode)"
          />
          <br />
          <vue-code-highlight class="mt-3 ml-3 mr-3">{{
            embedCode
          }}</vue-code-highlight>
        </div>

        <div class="tab-text mt-5">
          <div class="vx-row">
            <!-- required -->
            <div class="vx-col w-full">
              <label class="vs-input--label"
                >{{ $t("RescheduleURL") }} <span class="red">*</span></label
              >
              <b-form-input
                v-validate="{
                  required: true,
                  regex:
                    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                }"
                size="lg"
                name="reschedule_url"
                :placeholder="$t('RescheduleURL')"
                v-model="reschedule_url"
                class="w-full"
                :data-vv-as="$t('RescheduleURL')"
              >
              </b-form-input>
              <span
                class="text-danger text-sm"
                id="reschedule_url"
                v-show="errors.has('reschedule_url')"
                >{{ errors.first("reschedule_url") }}</span
              >
              <b-button
                type="filled"
                @click.prevent="urlUpdate('reschedule_url')"
                class="mt-5 float-right block border-primary"
                variant="primary"
                >{{ $t("Save") }}</b-button
              >
            </div>
          </div>
        </div>
      </b-card>
      <br />
      <b-card>
        <h5>{{ $t("MeetingRoomWidget") }}</h5>
        <p class="mt-4">{{ $t("MeetingRoomWidgetText") }}</p>
        <form class="mt-5">
          <div class="tab-text">
            <div class="vx-row">
              <!-- required -->
              <div class="vx-col w-full">
                <label>{{ $t("Rooms") }}</label>
                <v-select
                  v-model="room"
                  :options="rooms"
                  :placeholder="$t('SelectRoom')"
                  @input="changeRoomCode"
                  :clearable="false"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon">{{ option.label }} </span>
                    <feather-icon
                      v-if="room && room === option.label"
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-col mt-5 w-full">
            <div style="border: 1px solid">
              <feather-icon
                class="float-right mt-1 mr-1"
                style="cursor: pointer"
                v-b-tooltip.hover
                :title="$t('Copy')"
                icon="CopyIcon"
                svgClasses="w-6 h-6 hover:text-danger stroke-current"
                @click="copyCode(roomEmbedCode)"
              />
              <br />
              <vue-code-highlight class="mt-3 ml-3 mr-3">{{
                roomEmbedCode
              }}</vue-code-highlight>
            </div>
          </div>

          <div class="tab-text mt-5">
            <div class="vx-row">
              <!-- required -->
              <div class="vx-col w-full">
                <label class="vs-input--label">{{ $t("RoomURL") }}</label>
                <b-form-input
                  v-validate="{
                    required: true,
                    regex:
                      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                  }"
                  size="lg"
                  name="room_url"
                  v-model="room_url"
                  class="w-full"
                  :data-vv-as="$t('RoomURL')"
                  :placeholder="$t('RoomURL')"
                >
                </b-form-input>
                <span
                  class="text-danger text-sm"
                  id="room_url"
                  v-show="errors.has('room_url')"
                  >{{ errors.first("room_url") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-col float-right">
            <b-button
              type="filled"
              @click.prevent="submitForm('room_url')"
              class="mt-5 block border-primary"
              variant="primary"
              >{{ $t("Save") }}</b-button
            >
          </div>
          <br />
          <br />
          <br />
        </form>
      </b-card>
      <br />
      <b-card>
        <h5>{{ $t("EmbedLiveChat") }}</h5>
        <!-- <p class="mt-4">{{ $t("MeetingRoomWidgetText") }}</p> -->
        <form class="mt-5">
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/4 md:w-1/4 xl:w-1/4 mt-5"
          >
            <div class="flex walk-card">
              <b-form-checkbox
                v-model="liveChat"
                size="lg"
                name="cell_width"
                switch
                @input="setLivechat($event)"
              >
              </b-form-checkbox>
              <span class="ml-4 mt-1">{{ $t("EmbedLiveChat") }}</span>
            </div>
          </div>
          <br />
          <div class="vx-col" v-if="liveChat">
            <label class="vs-input--label"
              >{{ $t("Department") }} <span class="red">*</span></label
            >

            <v-select
              name="department"
              id="department"
              class=""
              v-model="department"
              v-validate="'required'"
              label="department_name"
              :options="options"
              :data-vv-as="$t('Department')"
              outlined
              :menu-props="{ maxHeight: 200 }"
              :placeholder="$t('Search')"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.department_name }} </span>
                <feather-icon
                  v-if="department.id == option.id"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('department')"
              >{{ errors.first("department") }}</span
            >
          </div>

          <!-- <div class="vx-col mt-5" v-if="showStaffList">
            <label class="vs-input--label">
              {{ $t("Staffs") }} <span class="red">*</span>
            </label>
            <v-select
              name="staff"
              id="staff"
              class=""
              v-model="staff"
              v-validate="'required'"
              label="name"
              :options="staffList"
              :data-vv-as="$t('Staff')"
              :placeholder="$t('Search')"
            >
              <template v-slot:option="option">
                <span :class="option.icon"
                  >{{ option.name }}
                </span>
                <feather-icon
                  v-if="staff && staff.id == option.id"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('staff')"
              >{{ errors.first("staff") }}</span
            >
          </div> -->

          <div class="vx-col float-right">
            <b-button
              type="filled"
              @click.prevent="enableLiveChat('department')"
              class="mt-5 block border-primary"
              variant="primary"
              >{{ $t("Save") }}</b-button
            >
          </div>
          <br />
          <br />
          <br />
        </form>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import $ from "jquery";
import moment from "moment";
import { getFrontendUrl } from "@/utils/stripe";

// For custom error message
import { Validator } from "vee-validate";
const filePath = "views/company/settings/Embed.vue";

export default {
  components: {
    vSelect,
    flatPickr,
    VueCodeHighlight,
  },
  computed: {},
  data() {
    return {
      embedCodeDepartment: null,
      enable: false,
      company: [],
      frontendURL: "",
      roomEmbedCode: "",
      rooms: [],
      room: "",
      room_url: "https://",
      roomList: [],
      reschedule_url: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      titleVal: "",
      department: "",
      options: [],
      showStaffList: false,
      staff: "",
      staffList: [],
      showDirectDepartment: true,
      liveChat: false,
    };
  },
  computed: {
    embedCode() {
      const title = this.titleVal || this.$store.getters.whitelabel.title;
      const department_slug =
        this.embedCodeDepartment && this.embedCodeDepartment.slug
          ? this.embedCodeDepartment.slug
          : null;

      if (this.$route.query.iframe === "ENABLED") {
        let url = `${this.frontendURL}${this.company.company_slug}`;
        if (department_slug) url += `/direct/${department_slug}`;
        return `<!-- ${title} Appointment Booking Embedded -->\n<iframe id="confhub-embed-iframe" allowtransparency="true" src="${url}" style="border: none;height: 800px;width: 100%;"></iframe>\n<script src="${this.frontendURL}confhub.embed.js" />\n<!-- \\${title} Appointment Booking Embedded -->\n`;
      }

      let input = `<input type="hidden" value="${this.company.company_slug}" id="company">\n`;

      if (department_slug)
        input += `<input type="hidden" value="${department_slug}" id="department">\n`;

      return (
        "<!-- " +
        title +
        " Appointment Booking Embedded -->\n" +
        '<link href="' +
        this.frontendURL +
        'css/app.css" rel="stylesheet"/>\n' +
        input +
        '<appointment-widget title="Appointments"></appointment-widget>\n' +
        '<script src="' +
        this.frontendURL +
        '/js/app.js" />\n'
      );
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
    department(value) {
      this.department = value || "";
      this.checkDepartment = false;
      if (this.department == "" || Object.keys(this.department).length < 0) {
        this.checkDepartment = true;
        this.offer = false;
      }
      this.slots = [];
      // this.getDepartmentSlots();

      if (this.addNewFrom) {
        this.getTimeSlots();
      }
    },
    staff(value) {
      this.staff = value || "";
    },
  },
  mounted() {
    this.loadLocale(this.$i18n.locale);
    this.company = this.$store.getters.currentUser;
    this.enable = this.company.enable_header_footer_for_embedded ? true : false;
    // this.frontendURL = getFrontendUrl();
    this.frontendURL = this.$store.getters.whitelabel.embed_url + "/";
    this.getSettings();
    // this.getRooms();
    // this.loadLocale(value);
    this.getDepartments();
  },
  methods: {
    /**
     * room list
     */
    setHeader() {
      this.show = true;
      let id = this.company.id;
      let data = {
        company_id: id,
        is_enable: this.enable ? 1 : 0,
      };
      this.$store
        .dispatch("SetHeaders", data)
        .then((res) => {
          this.show = false;
          this.$store.getters.currentUser.enable_header_footer_for_embedded =
            this.enable;
          this.$store.commit("SET_USER", this.$store.getters.currentUser);
          this.$toasted.show(this.$t("UpdateHeader"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            `File : ${filePath} | Function : setHeader() | Error :`,
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    changeRoomCode() {
      this.room_url = this.roomList[this.room].room_url;
      this.roomEmbedCode =
        "<!-- " +
        this.titleVal +
        " Meeting Room Embedded -->\n" +
        '<link href="' +
        this.frontendURL +
        'css/app.css" rel="stylesheet"/>\n' +
        '<input type="hidden" value="' +
        this.room +
        '" id="room-name">\n' +
        '<appointment-widget title="Appointments"></appointment-widget>\n' +
        '<script src="' +
        this.frontendURL +
        '/js/app.js" />\n';
    },
    /**
     * room list
     */
    getRooms() {
      this.show = true;
      this.$store
        .dispatch("RoomList", this.company.id)
        .then((res) => {
          this.show = false;
          this.rooms = res.data.data;

          this.rooms = res.data.data.map((room) => {
            return room.room_name;
          });
          res.data.data.forEach((element) => {
            this.roomList[element.room_name] = element;
          });
          this.room = this.$route.params.room
            ? this.$route.params.room
            : this.rooms[0];
          this.room_url = this.roomList[this.room].room_url;
          this.reschedule_url = this.roomList[this.room].company_url;

          this.changeRoomCode();
        })
        .catch((error) => {
          this.$log.error(
            `File : ${filePath} | Function : getRooms() | Error :`,
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    /**
     * copy embed text
     */
    copyCode(code) {
      this.$copyText(code).then(
        (e) => {
          this.$toasted.show(this.$t("CopyText"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        },
        function (e) {
          this.$toasted.show(this.$t("CopyTextError"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        }
      );
    },
    /**
     *  Company Url method for submiting form
     **/
    urlUpdate(value) {
      this.$validator.validate(value).then((result) => {
        if (result) {
          this.show = true;
          let data = {
            company_url: this.reschedule_url,
            company_id:
              this.$store.getters.roles == "assistant"
                ? this.$store.getters.currentUser.company_id
                : this.$store.getters.currentUser.id,
          };
          this.$store
            .dispatch("UrlUpdate", data)
            .then((res) => {
              this.show = false;
              this.$toasted.show(this.$t("RecheduleUrlUpdate"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            })
            .catch((error) => {
              this.$log.error(
                `File : ${filePath} | Function : urlUpdate() | Error :`,
                error
              );
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !==
                error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
              return false;
            });
        }
      });
    },
    /**
     *  submitForm method for submiting form
     **/
    submitForm(value) {
      this.$validator.validate(value).then((result) => {
        if (result) {
          this.show = true;
          let data = {
            room_url: this.room_url,
            room_id: this.roomList[this.room].id,
          };
          this.$store
            .dispatch("RoomUrlSave", data)
            .then((res) => {
              this.show = false;
              this.$toasted.show(this.$t("RoomUpdated"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            })
            .catch((error) => {
              this.$log.error(
                `File : ${filePath} | Function : submitForm() | Error :`,
                error
              );
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !==
                error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
              return false;
            });
        }
      });
    },

    async getSettings() {
      try {
        const res = await this.$store.dispatch("GetSystemSettings");
        this.titleVal = res.data.data.title;
        this.frontendURL = res.data.data.embed_url + "/";
        this.getRooms();
        this.getLivechatData();
      } catch (error) {
        console.error(error);
      }
    },

    getLivechatData() {
      let id = this.company.id;
      this.show = true;
      this.$store
        .dispatch("CompanyDetails", this.company.company_slug)
        .then((res) => {
          this.show = false;
          this.embedChat = res.data.data;
          console.log("Rooms", this.embedChat);

          if (this.embedChat.enable_live_chat == true) {
            this.liveChat = true;
            this.department =
              this.embedChat.live_chat_department.department_name;
          }
          // this.rooms = res.data.data.map((room) => {
          //   return room.room_name;
          // });
          // res.data.data.forEach((element) => {
          //   this.roomList[element.room_name] = element;
          // });
          // this.room = this.$route.params.room
          //   ? this.$route.params.room
          //   : this.rooms[0];
          // this.room_url = this.roomList[this.room].room_url;
          // this.reschedule_url = this.roomList[this.room].company_url;

          // this.changeRoomCode();
        })
        .catch((error) => {
          this.$log.error(
            `File : ${filePath} | Function : getRooms() | Error :`,
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    enableLiveChat(value1) {
      console.log("form value", value1);
      let id = this.company.id;
      this.$validator.validate(value1).then((result) => {
        if (result) {
          this.show = true;
          let data = {
            company_id: id,
            enable_live_chat: this.liveChat,
            department_id: this.department.id,
            staff_id: this.staff.id,
          };
          console.log("requdata", data);
          this.$store
            .dispatch("EnabledLiveChat", data)
            .then((res) => {
              this.show = false;
              this.$toasted.show(this.$t("EnabledLiveChat"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            })
            .catch((error) => {
              this.$log.error(
                `File : ${filePath} | Function : submitForm() | Error :`,
                error
              );
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !==
                error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
              return false;
            });
        }
      });
    },

    // changeDepartment(department) {
    //   console.log('Department', department)
    //   this.timeSlots = [];
    //   this.selectdSlotIds = [];
    //   this.staff = '';
    //   this.showStaffList = false;
    //   if(department == null) {
    //     this.participates = null;
    //   }

    //    {
    //      this.showStaffList = true;
    //   }

    //   if(this.department) {
    //     console.log('call staff');
    //      var data = { department_id: this.department.id };
    //      this.$store.dispatch("GetDeptStaffList", data).then((res) => {
    //        this.staffList = res.data.data;
    //         this.staffList.forEach((element, index) => {
    //           this.staffList[index].name =
    //             element.first_name + " " + element.last_name;
    //         });
    //     });
    //   }

    // },

    getDepartments() {
      this.show = true;
      console.log("showDirectDepartment", this.showDirectDepartment);
      let role = this.$store.getters.roles;
      var data = {
        company_id:
          role == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        direct_filter: this.showDirectDepartment,
      };
      let action =
        role == "staff"
          ? "StaffDepartmentsWithFilter"
          : "DepartmentsWithFilter";
      this.$store
        .dispatch(action, data)
        .then((res) => {
          this.show = false;
          console.log("test", res);
          this.options = res.data.data;
          this.totalRows = this.department.length;
        })
        .catch((error) => {
          this.$log.error(
            `File : ${filePath} | Function : getDepartments() | Error :`,
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    setLivechat(e) {
      console.log("Live", e);
      if (e == true) {
        this.liveChat = true;
      } else {
        this.liveChat = false;
        this.showStaffList = false;

        let id = this.company.id;
        let data = {
          company_id: id,
          enable_live_chat: this.liveChat,
          department_id: null,
          staff_id: null,
        };
        this.$store
          .dispatch("EnabledLiveChat", data)
          .then((res) => {
            this.show = false;
            this.$toasted.show(this.$t("EnabledLiveChat"), {
              className: "top-alert",
              position: "top-center",
              type: "success",
              duration: 2000,
            });
          })
          .catch((error) => {
            this.$log.error(
              `File : ${filePath} | Function : submitForm() | Error :`,
              error
            );
            this.show = false;
            // Error response
            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
            return false;
          });
      }
    },
  },
};
</script>
<style lang="stylus" scoped></style>
